import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { ModuleStatus } from "../types";
import { ModuleDB } from "./Modules";

export const updateModuleStatus = async (
  moduleId: string,
  status: ModuleStatus,
) => {
  const collectionRef = collection(db, "moduleTemplates");

  await updateDoc(doc(collectionRef, moduleId), {
    status,
    updatedAt: new Date(),
  });

  const moduleTemplateSnapshot = await getDoc(doc(collectionRef, moduleId));

  const updatedModuleTemplate = new ModuleDB(moduleTemplateSnapshot);

  return updatedModuleTemplate.toModule();
};
